const data = [
    {
        id: 1,
        name: 'Sandip Karmokar',
        email: 'sandip@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: '',
    },
    {
        id: 2,
        name: 'Gayrish',
        email: 'gayrish@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
    {
        id: 3,
        name: 'John Smith',
        email: 'john@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
    {
        id: 4,
        name: 'Edward Kenway',
        email: 'edward@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
    {
        id: 5,
        name: 'Mason Wood',
        email: 'mason@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
    {
        id: 6,
        name: 'Frank Wood',
        email: 'frank@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
    {
        id: 7,
        name: 'David',
        email: 'david@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
    {
        id: 8,
        name: 'George',
        email: 'george@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
    {
        id: 9,
        name: 'Frenkie',
        email: 'frenkie@gmail.com',
        phone: 1800180180,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate ipsum orci ultrices pellentesque id sagittis.',
        status: 'status',
    },
];

export default data;
